import React from 'react';
import useDecisionTreeRunContext from '../../Contexts/DecisionTree/DecisionTreeRunContext/useDecisionTreeRunContext';
import Suspense from '../../Suspense';

const DecisionTreePage = React.lazy(() => import('./Pages/DecisionTreePage'));
const DecisionTreeListPage = React.lazy(() => import('./Pages/DecisionTreeListPage'));

export default function DecisionTreeRouter() {
  const { runId } = useDecisionTreeRunContext();
  if (runId) {
    return <Suspense><DecisionTreePage /></Suspense>;
  }
  return <Suspense><DecisionTreeListPage /></Suspense>;
}
